<template>
  <section class="jps-curation-section" :id="def.cpid"
    :class="{
      'page-jps': isJps,
      'page-hina': isHina,
    }"
  >
    <h2 v-if="!isEmpty(def.title)" class="jps-curation-section-title">
      <span>
        <template v-if="def.icon && isJps">
          <BaseIcon class="jps-red" :name="processedIconName" /> <br />
        </template>
        {{ ls(def.title) }}
      </span>
    </h2>
    <CurationPartsRenderer
      :curation="curation"
      :parts="def.parts"
    />
  </section>
</template>

<script lang="ts" setup>
import type { SVG_NAMES } from '~/components/icons'

const { ls } = useI18n()
const { isJps, isHina } = useServiceType()

interface Props {
  def: PartSection
  curation: Curation
}
const props = withDefaults(defineProps<Props>(), {})
const processedIconName = computed(() => {
  if (!props.def.icon) return '';
  const iconName = patchKoiconName(props.def.icon)
  return iconName as SVG_NAMES;
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-curation-section {
  padding-top: 2.5rem;
  @include is-tablet {
    padding-top: 4rem;
  }
  .jps-curation-section-title {
    font-size: 1rem;
    font-weight: 700;
    text-align: center;
    margin-bottom: 0;
    margin-top: 1.5rem;
    @include is-tablet {
      font-size: 1.5rem;
      margin-bottom: 1rem;
    }
  }
  .jps-curation-section {
    .jps-curation-section-title {
      border-bottom: none;
      @include is-tablet {
        font-size: 1.5rem;
      }
    }
    .jps-curation-section {
      .jps-curation-section-title {
        border-bottom: none;
        @include is-tablet {
          font-size: 1.25rem;
        }
      }
    }
  }
}

.page-hina {
  .jps-curation-section-title {
    font-weight: normal !important;
  }

  :deep(.has-text-weight-bold) {
    font-weight: normal !important;
  }
}
</style>
